import React from 'react';
import classNames from 'classnames';
import { string } from 'prop-types';
import { metric, logger } from '@fiverr-private/perseus';
import { getContext, I18n } from '@fiverr-private/fiverr_context';
import { Icon } from '@fiverr-private/fit';
import { l_arrow_right } from '@fiverr-private/icons';
import { isEmpty } from 'lodash';
import {
    MP_CLICKED_BRAND_LANDING_PAGE_LINK,
    MP_CLICKED_BRAND_VIDEO_PREVIEW,
    MP_CLOSED_BRAND_VIDEO_PLAYER,
    MP_SHOW_BRAND_VIDEO_PLAYER
} from '../../../../utils/biEvents/events/mixPanelEvents';
import {
    BQ_CLICKED_BRAND_LANDING_PAGE_LINK,
    BQ_CLICKED_BRAND_VIDEO_PREVIEW,
    BQ_CLOSED_BRAND_VIDEO_PLAYER,
    BQ_SHOW_BRAND_VIDEO_PLAYER
} from '../../../../utils/biEvents/events/bigQueryEvents';
import { LOCALES } from '../../../../utils/constants';
import { sendBigQueryEvent, sendMixPanelEvent } from '../../../../utils/biEvents';
import VideoPreview from '../VideoPreview';
import {
    BRAND_LANG_URL,
    THUMBNAIL_PREVIEW_URL,
    VIDEO_PREVIEW_VIDEO_URL
} from './constants';
import './style.scss';

const Brand = ({
    className
}) => {
    const { locale } = getContext();

    const onVideoPreviewClick = () => {
        sendMixPanelEvent({ eventName: MP_CLICKED_BRAND_VIDEO_PREVIEW });
        sendBigQueryEvent({ eventName: BQ_CLICKED_BRAND_VIDEO_PREVIEW });
        sendGraphiteEvent('video_preview_clicked');
    };

    const onVideoModalClose = () => {
        sendMixPanelEvent({ eventName: MP_CLOSED_BRAND_VIDEO_PLAYER });
        sendBigQueryEvent({ eventName: BQ_CLOSED_BRAND_VIDEO_PLAYER });
        sendGraphiteEvent('video_closed');
    };

    const onVideoModalOpen = () => {
        sendMixPanelEvent({ eventName: MP_SHOW_BRAND_VIDEO_PLAYER });
        sendBigQueryEvent({ eventName: BQ_SHOW_BRAND_VIDEO_PLAYER });
        sendGraphiteEvent('video_opened');
    };

    const onCtaClick = () => {
        sendMixPanelEvent({ eventName: MP_CLICKED_BRAND_LANDING_PAGE_LINK });
        sendBigQueryEvent({ eventName: BQ_CLICKED_BRAND_LANDING_PAGE_LINK });
        sendGraphiteEvent('cta_clicked');
    };

    const sendGraphiteEvent = (eventKey) => {
        metric.count(`brand_campaign.widget.${eventKey}`);
    };

    const wrapperClass = classNames(
        'brand-campaign',
        'video-campaign',
        className
    );

    let localeUrls = BRAND_LANG_URL[locale];

    if (isEmpty(localeUrls)) {
        logger.error('Branding render for unsupported locale', { locale });

        localeUrls = BRAND_LANG_URL[LOCALES.en];
    }

    return (
        <div className={wrapperClass}>
            <VideoPreview videoUrl={localeUrls.VIDEO}
                previewImgUrl={THUMBNAIL_PREVIEW_URL}
                previewVideoUrl={VIDEO_PREVIEW_VIDEO_URL}
                titleTextKey="logged_out_homepage.brand_campaign.every_successful_something_was_nothing"
                onPreviewClick={onVideoPreviewClick}
                onVideoOpen={onVideoModalOpen}
                onVideoClose={onVideoModalClose}/>

            {/* eslint-disable-next-line react/jsx-no-target-blank */}
            <a href={localeUrls.CTA} target="_blank" onClick={onCtaClick} rel="nofollow">
                <p>
                    <I18n k="logged_out_homepage.brand_campaign.discover_how_to_get_it_done"/>
                    <Icon className="right-arrow-icon" size={20}>
                        {l_arrow_right}
                    </Icon>
                </p>
            </a>
        </div>
    );
};

Brand.propTypes = {
    className: string
};

export default Brand;
